<div class="row">
  <div class="col">
    <h3>{{titulo}}</h3>
  </div>
  <div class="col-auto d-flex">
    <div class="col-auto" *ngIf="tipoArquivoExemplo">
      <button class="btn btn-secondary" type="button" 
          (click)="preparaArquivoExemplo()"
          placement="bottom" ngbTooltip="Exporta um arquivo de exemplo para o envio de {{tipoArquivoExemplo}}.">
        <i class="fa fa-file"></i> {{textoBtnArquivoExemplo}}</button>
    </div>
    <div class="col-auto" *ngIf="janelaEnvioAberta">
      <button class="btn btn-secondary" type="button" (click)="limpar()" placement="bottom">
        <i class="fa fa-file"></i> Limpar</button>
    </div>

    <div class="col-auto">
        <button class="btn btn-primary" type="button" [routerLink]="routerLinkPesquisaLote">Voltar</button>
      </div>

    <div class="col-auto">
      <button *ngIf="!enviado && janelaEnvioAberta" [disabled]="!protocoloForm.valid || protocoloForm.pristine" type="button" (click)="onSubmit()"
        class="btn btn-primary" type="button"
        ngbTooltip="Enviar arquivo">Enviar</button>
    </div>
  </div>
</div>
<div class="col">
 <span *ngIf="janelaEnvioAberta"><p>{{instrucoesEnvio}}</p></span>
 <span *ngIf="mensagemAlerta" ><p class="color-red"><i class="fas fa-exclamation-triangle"></i> {{mensagemAlerta}}</p></span>
  <div class="container" *ngIf="janelaEnvioAtual">
    <div class="row">
      <label>Data de abertura da janela: {{janelaEnvioAtual.dataAbertura| date:'dd/MM/yyyy'}}.</label>
    </div>
    <div class="row">
      <label>Data de fechamento da janela: {{janelaEnvioAtual.dataFechamento| date:'dd/MM/yyyy'}}.</label>
    </div>
  </div>
</div>

<div class="container" *ngIf="janelaEnvioAberta">
  <form [formGroup]="protocoloForm" (validSubmit)="onSubmit()">

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="arquivo">Arquivo:</label>
        <div id="customFile">
          <input type="file" [accept]="tipoArquivoAceito == 'csv' ? '.csv' : '.json'" class="form-control" id="arquivo" (change)="onFileChange($event)" #fileInput [disabled]="enviado" formControlName="arquivo"/>
        </div>
        <label class="form-label arquivo-selecionado" *ngIf="arquivo?.tipoConteudo">Arquivo de {{labelTipoConteudo}} selecionado para envio</label>
      </div>
    </div>
    <div class="row" *ngIf="mostrarBotoesDeOpcao">
        <div class="col-md-3">
          <input type="radio" value="validar" formControlName="opcaoEnvio"> Apenas validar

        </div>
        <div class="col-md-2">
          <input type="radio" value="contratar" formControlName="opcaoEnvio"> Efetivar envio
        </div>
    </div>
    <br>

  </form>
</div>

<div *ngIf="operacoes?.length > 0" class="erros-upload">
  <div class="row">
    <div class="col">
      <h4>Sucesso no envio do arquivo</h4>
    </div>
  </div>
</div>

<div *ngIf="ocorrencias?.length > 0" class="erros-upload">
  <div class="row">
    <div class="col">
      <h4>Erros no envio do arquivo</h4>
    </div>

    <div class="col-auto">
      <button class="btn btn-secondary" type="button" (click)="baixarTabelaDeErros()" placement="bottom"
        ngbTooltip="Exporta arquivo JSON com os erros encontrados.">
        <i class="fa fa-file"></i> Exportar erros</button>
    </div>
  </div>
</div>

<div>
  <div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="table-responsive">
      <table class="table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-center">
              Identificador
            </th>
            <th class="text-center">
              Erro(s) encontrado(s)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ocorrencia of ocorrencias">
              <td width="20%">
                  {{ ocorrencia.idObjetoValidado }}
              </td>
              <td width="80%">
                  {{ ocorrencia.mensagem }}
              </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p *ngIf="tipoArquivoAceito == 'csv'" class="obs-erro" >Nenhuma informação do arquivo foi recebida. Arquivo csv inválido. Verifique o formato, a extensão e o conteúdo do arquivo.</p>
    <p *ngIf="tipoArquivoAceito != 'csv'" class="obs-erro" >Nenhuma informação do arquivo foi recebida. Em caso de parâmetro inválido com mensagem "não deve ser nulo", verificar se o nome do parâmetro está correto no JSON enviado.</p>
  </div>
</div>

<bn-loading-overlay></bn-loading-overlay>
